<form
            class="search-filter"
            [ngClass]="{'search-filter-focused': searchFilterFocused}"
            #searchForm="ngForm"
            
        >
            <label for="search-filter-field" class="icon" >
                <svg *ngIf="!searchFilterFocused" xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path fill="none" stroke="#15151c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20" d="M6 1a5 5 0 110 10A5 5 0 016 1zM13.002 13.002L9.535 9.535"/></svg>
                <svg *ngIf="searchFilterFocused" xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path fill="none" stroke="#15151c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20" d="M6 1a5 5 0 110 10A5 5 0 016 1zM13.002 13.002L9.535 9.535"/></svg>
            </label>
            <input
                
                name="searchString"
                type="text"
                class="txt"
                id="search-filter-field"
                placeholder="{{searchFilterFocused ? 'Search titles, networks' : 'Search'}}"
                (focus)="searchFilterFocused = true"
                (input)="getSearchVal($event.target.value)"
            >
            <input
                type="reset"
                value="Cancel"
                class="btn-reset"
                (click)="searchFilterFocused = false;searchString = ''"
            >
            <input type="submit" value="Search" class="btn-submit" 
            (click)="filterData(searchString)">
            <!-- <mat-select class="search-category-select" [(ngModel)]="searchCategory" (ngModelChange)="unassignMapping(i)"> -->
            <!-- <mat-select class="search-category-select" [(ngModel)]="searchCategory">
                <mat-option disabled>Select a Partner Group</mat-option>
                <mat-option *ngFor="let group of partnerGroups;" [value]="group">{{group.name}}</mat-option>
            </mat-select> -->
        </form>

<mat-table [dataSource]="tableData" matSort class="track-list" multiTemplateDataRows>
    <ng-container matColumnDef="import_pro_mapped_headers_profile">
        <mat-header-cell mat-sort-header *matHeaderCellDef>Profile ID</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.import_pro_mapped_headers_profile }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="pro_type">
        <mat-header-cell mat-sort-header *matHeaderCellDef>Import Type</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.pro_type }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="pro_year">
        <mat-header-cell mat-sort-header *matHeaderCellDef>Year</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.pro_year }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="pro_quarter">
        <mat-header-cell mat-sort-header *matHeaderCellDef>Quarter</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.pro_quarter }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="status">
        <mat-header-cell mat-sort-header *matHeaderCellDef>Status</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.status }}</mat-cell>
    </ng-container>
    <!-- todo: add stats column(s) -->
    <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
            <button class="button" (click)="navigateToMapShowsTable(row)">Map Shows</button>
            <button class="button" (click)="navigateToMapPartnerGroupsTable(row)">Map Partner Groups</button>
            <button class="button">Create Episodes (Pending Dev)</button>
            <button class="button" (click)="confirmDelete(row)">Delete</button>
        </mat-cell>
    </ng-container>

    <!-- <ng-container matColumnDef="genre">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Genre</mat-header-cell>
        <mat-cell *matCellDef="let row">
            {{ row.genre && row.genre.parent ? row.genre.parent.name : row.genre ? row.genre.name : "" }}
        </mat-cell>
    </ng-container> -->

    <!-- <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
        <mat-cell *matCellDef="let row">
            <span *ngIf="row.status == 'PENDING'" class="status-bullet" style="background-color: #E3B950;"
                [matTooltip]="pendingBtn" matTooltipPosition="left" matTooltipClass="tooltip-white"></span>
            <span *ngIf="row.status == 'PENDING_APPROVAL'" class="status-bullet" style="background-color: #47CDEF;"
                [matTooltip]="pendingApproveBtn" matTooltipPosition="left" matTooltipClass="tooltip-white"></span>
            <span *ngIf="row.status == 'APPROVED'" class="status-bullet" style="background-color: #50E3C2;"
                [matTooltip]="approveBtn" matTooltipPosition="left" matTooltipClass="tooltip-white"></span>
            <span *ngIf="row.status == 'DENIED'" class="status-bullet" style="background-color: #D73939;"
                [matTooltip]="denieBtn" matTooltipPosition="left" matTooltipClass="tooltip-white"></span>
            <span *ngIf="row.status == 'DISABLED'" class="status-bullet" style="background-color: #8A8A8D;"
                [matTooltip]="disableBtn" matTooltipPosition="left" matTooltipClass="tooltip-white"></span>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
            <button type="button" (click)="$event.preventDefault();$event.stopPropagation();rowClicked1(row)"
                class="versions-toggle" class="expand-button">
                <svg width="10px" height="5px" viewBox="0 0 10 5" class="carrot"
                    [ngClass]="{ flip: trackIsExpanded(row) }">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"
                        stroke-linejoin="round">
                        <g transform="translate(-1392.000000, -396.000000)" class="inner-stroke" stroke-width="0.95">
                            <g transform="translate(392.000000, 351.000000)">
                                <g transform="translate(920.550000, 36.100000)">
                                    <polyline points="80.75 9.5 84.55 13.3 88.35 9.5"></polyline>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </button>
        </mat-cell>
    </ng-container> -->

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" class="main-row"></mat-row>
    <!-- <mat-row *matRowDef="let row; columns: displayedColumns" class="main-row"
        [ngClass]="{ expanded: trackIsExpanded(row) }" (click)="rowClicked1(row)"></mat-row> -->
    <!-- <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"
        [@detailExpand]="trackIsExpanded(row) ? 'expanded' : 'collapsed'"></mat-row> -->
</mat-table>

<mat-paginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons aria-label="Select page of periodic elements"></mat-paginator>

<div class="loading-overlay" *ngIf="isFetchingTableData">
    <app-loader color="#50e3c2"></app-loader>
</div>
